import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";

export const CustomContent = styled(Dropdown.Content)`
  min-width: initial;
`;

export const CustomSeparator = styled(Dropdown.Separator)`
  display: flex;
`;
